import { parseDotenvFile } from '@cli-utils/files.js'

/**
 * Connecting a store writes `BLOB_READ_WRITE_TOKEN`, but a custom env-var prefix on the connection
 * produces `<PREFIX>_READ_WRITE_TOKEN` instead.
 */
export function readBlobTokenFromDotenv(filePath: string): string | undefined {
  const vars = parseDotenvFile(filePath)

  const isBlobToken = (v: string | undefined): v is string => !!v && v.startsWith('vercel_blob_rw_')

  if (isBlobToken(vars.get('BLOB_READ_WRITE_TOKEN'))) return vars.get('BLOB_READ_WRITE_TOKEN')
  for (const [key, value] of vars) {
    if (key.endsWith('_READ_WRITE_TOKEN') && isBlobToken(value)) return value
  }
  for (const value of vars.values()) {
    if (isBlobToken(value)) return value
  }
  return undefined
}
